export default __webpack_public_path__ + "static/media/tee.ce28a2a2.png";